export const OWNER_OPTIONS = ["Anyone", "Me"];
